import http from "../http/http-config";
import { HouseType } from "../models/houseType";

export default new class houseTypeService {
    getHousingTypes(): Promise<HouseType[]> {
        return http.get<HouseType[]>("GetHouseType", {
            params: {
            }
        }).then(response => response.data)
    }
}